import { render, staticRenderFns } from "./PasswordConfirmation.vue?vue&type=template&id=64bf57b3&scoped=true&"
import script from "./PasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./PasswordConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PasswordConfirmation.vue?vue&type=style&index=0&id=64bf57b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf57b3",
  null
  
)

export default component.exports